<template>
  <v-autocomplete
    :loading="isLoading"
    :items="items"
    :search-input.sync="search"
    flat
    clearable
    no-filter
    v-model="model"
    :disabled="disabled"
    item-text="name"
    item-value="id"
    :item-disabled="isDisabled"
    :label="label"
    :rules="rules"
    @change="onChange"
  >
    <template v-slot:selection="data">
        <i class="availability" v-bind:class="{ available: data.item.available > 0 }"></i>
        {{ data.item.name }}
        <v-chip v-if="data.item.status != 'active'" :color="data.item.status == 'active' ? 'green':'grey'" text x-small class="ml-2" >{{data.item.status == 'active' ? 'Active' : 'Inactive'}}</v-chip>
    </template>
    <template v-slot:item="data">
        <v-list-item-avatar>
          <i class="availability" v-bind:class="{ available: data.item.available > 0 }"></i>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{data.item.name}} - {{data.item.brand}}</v-list-item-title>
          <v-list-item-subtitle>available: {{ data.item.available }} | incoming : {{data.item.incoming}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-chip  v-if="data.item.status != 'active'" :color="data.item.status == 'active' ? 'green':'grey'" text x-small class="ml-2" >{{data.item.status == 'active' ? 'Active' : 'Inactive'}}</v-chip>
        </v-list-item-icon>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      //model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      search: null,
      isLoading: false,
      items: [],
      searchFilters: this.filters
    };
  },
  props: {
    value: {
      type: Number
    },
    label: {
      type: String
    },
    filters: {
      type: Object
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input', value);
      }
      /*set(value){
        this.$emit('input', this.model);
        this.$emit("productSelected", this.items.find(i => i.id == value))
      }*/
    }
  },
  watch: {
    value() {
      this.getProducts();
    },
    
    search: {
      handler: _.debounce(function() {
        this.getProducts();
      }, 400)
    },
    filters() {
      if (this.filters) {
        this.searchFilters = this.filters;
        this.getProducts();
      }
    },
  },
  mounted: function() {
    if (this.searchFilters || this.value) {
      this.getProducts();
    }
  },
  methods: {
    isDisabled(product){
      return product.status=="inactive"
    },
    getProducts() {
      if (this.model) {
        this.$store.dispatch("products/get", {id:this.model} )
          .then(({data}) => {
            this.items = [data];
          })
          .finally(() => (this.isLoading = false));
      } else {
        if (this.disabled) return true;
        if (this.isLoading) return true;
        this.isLoading = true;
        this.$store
          .dispatch("products/index", {
            search: this.search,
            filters: this.searchFilters
          })
          .then(({products}) => {
            this.items = products.data;
          })
          .finally(() => (this.isLoading = false));
      }
    },
    onChange(value) {
      this.$emit("input", value);
      this.$emit("productSelected", this.items.find(i => i.id == value));
    }
  }
};
</script>

<style lang="less" scoped>
.availability {
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: red;
  margin-right: 1rem;
  &.available {
    background-color: green;
  }
}
</style>
